var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMarkIcon = function SvgCheckMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.766 1.457-4.22 4.22a.8.8 0 0 1-1.133 0L.234 3.497a.8.8 0 0 1 1.133-1.131l1.612 1.612L6.633.324a.8.8 0 0 1 1.133 1.133"
  })));
};
export { SvgCheckMarkIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjYiIHZpZXdib3g9IjAgMCA4IDYiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0ibTcuNzY2IDEuNDU3LTQuMjIgNC4yMmEuOC44IDAgMCAxLTEuMTMzIDBMLjIzNCAzLjQ5N2EuOC44IDAgMCAxIDEuMTMzLTEuMTMxbDEuNjEyIDEuNjEyTDYuNjMzLjMyNGEuOC44IDAgMCAxIDEuMTMzIDEuMTMzWiIvPjwvc3ZnPg==";